import { FC } from "react";

import Checkbox from "components/checkbox";
import { Select } from "components/select";

import { SearchFiltersData } from "../SiteSearch";

interface Props {
  filters: SearchFiltersData;
  facets: string[];
  handleFacetChange: (value: string, checked: boolean) => void;
  handleSortChange: (value: string) => void;
}

export const SearchFilters: FC<Props> = ({
  filters,
  facets,
  handleFacetChange,
  handleSortChange,
}) => {
  return (
    <div className="search-filters">
      {filters.map((filter) => {
        if (filter.type === "select") {
          return (
            <div className="search-filters__filter" key={filter.key}>
              <Select
                label={filter.title}
                name="sortBy"
                options={filter.options.map((option: any) => ({
                  label: option.title,
                  value: option.key,
                }))}
                onChange={(e) => handleSortChange(e.target.value)}
              />
            </div>
          );
        }

        if (filter.type === "radios") {
          return (
            <div className="search-filters__filter" key={filter.key}>
              <h3 className="search-filters__title">{filter.title}</h3>
              <ul className="search-filters__list">
                {filter.options.map((option: any) =>
                  option.key !== "all" ? (
                    <li
                      key={option.key}
                      onClick={() =>
                        handleFacetChange(
                          option.key,
                          !facets.includes(option.key)
                        )
                      }
                    >
                      <Checkbox
                        label={option.title}
                        name={option.slug}
                        value={option.key}
                        checked={facets.includes(option.key)}
                      />
                      <label htmlFor={option.id}>{option.title}</label>
                    </li>
                  ) : null
                )}
              </ul>
            </div>
          );
        }

        return null;
      })}
    </div>
  );
};
